import { APP_INITIALIZER, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationGuard } from './AuthenticationGuard';

export const appInitializerProvider = {
  provide: APP_INITIALIZER,
    useFactory: appInitializerFunction ,
  deps: [Injector],
  multi: true
}

export function appInitializerFunction(injector: Injector){
  return  (): Promise<any> => {
    return new Promise((resolve) => {
      var router = injector.get(Router);
      router.config.filter(route => !route.data || !route.data.skipGuard)
        .map(route => {
          route.canActivate = route.canActivate === undefined ? [AuthenticationGuard] : [AuthenticationGuard].concat(route.canActivate);
          route.canActivateChild = route.canActivateChild === undefined ? [AuthenticationGuard] : [AuthenticationGuard].concat(route.canActivateChild);
        });
      console.log("Authentication Guard Initialization");
      resolve();
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/security/services/AuthenticationGuard.AppInitializer.ts